var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isRedirect)?_c('CoreUI',{attrs:{"rendering":_vm.route}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }